export * from '@primeuix/themes/nora/progressspinner';
export { default } from '@primeuix/themes/nora/progressspinner';
